import React from "react";

import Tag, { TagProps } from "antd/es/tag";
import cn from "classnames";

import Colored from "@mapmycustomers/shared/types/base/Colored";
import Named from "@mapmycustomers/shared/types/base/Named";
import anyColorToHex from "@mapmycustomers/shared/util/color/anyColorToHex";
import getContrastColor from "@mapmycustomers/shared/util/color/getContrastColor";

import colors from "@app/styles/_colors.module.scss";
import getSemiTransparentColor from "@app/util/colors/getSemiTransparentColor";

import styles from "./EntityTag.module.scss";

interface Props extends Omit<TagProps, "style"> {
  children?: React.ReactNode;
  className?: string;
  entity: Colored & Named;
  textColor?: string;
}

// Forwards its ref to the underlying Tag so overlay components (Tooltip, Popover) can attach a
// trigger to it — antd clones its child with a ref and cannot position against a plain function
// component.
const EntityTag = React.forwardRef<HTMLSpanElement, Props>(
  ({ children, className, entity, textColor, ...props }, ref) => {
    const backgroundColor = entity.color ? getSemiTransparentColor(entity.color) : colors.white;
    const borderColor = entity.color ? anyColorToHex(entity.color) : colors.slate;

    const color = textColor
      ? textColor
      : getContrastColor(backgroundColor) === "black"
        ? colors.slate
        : borderColor;

    return (
      <Tag
        className={cn(styles.container, className)}
        ref={ref}
        style={{ backgroundColor, borderColor, color }}
        {...props}
      >
        {children ?? entity.name}
      </Tag>
    );
  }
);

export default EntityTag;
